import React from 'react';
import './App.css';
import {Route} from 'react-router-dom'
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import {Routes} from "react-router";
import OfflineUpdate from "./components/OfflineUpdate";
import UpdateLicense from "./components/UpdateLicense";
import LicenseActivate from "./components/LicenseActivate";

function App() {
    return (
        <div
            className="min-h-screen bg-white text-gray-900 transition-colors duration-300 dark:bg-gray-900 dark:text-gray-100">
            <Navbar/>
            <main>
                <Routes>
                    <Route path={'/'} element={<Hero/>}/>
                    <Route path={'/update'} element={<OfflineUpdate/>}/>
                    <Route path={'/offline-actions'} element={<UpdateLicense/>}/>
                    <Route path={'/activate'} element={<LicenseActivate/>}/>
                </Routes>
            </main>
            <Footer/>
        </div>
    );
}

export default App;
